import { render, staticRenderFns } from "./statement_use_detail.vue?vue&type=template&id=36d87be7&scoped=true&"
import script from "./statement_use_detail.vue?vue&type=script&lang=js&"
export * from "./statement_use_detail.vue?vue&type=script&lang=js&"
import style0 from "./statement_use_detail.vue?vue&type=style&index=0&id=36d87be7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d87be7",
  null
  
)

export default component.exports